import React, { useState } from "react";
import {
  Drawer,
  Button,
  Switch,
  Divider,
  DatePicker,
  TimePicker,
  notification,
  Input,
  InputNumber,
} from "antd";
import { useTriggerCommandMutation } from "../../../services/segmentation.services";
import moment from "moment";
import { useSelector } from "react-redux";
import { convertToNigerianTime } from "../../../utils/timezones";
import { errorBlock } from "../../../controllers/errorBlock";
import { useLoopTimerMutation } from "../../../services/commands.services";
import { useParams } from "react-router-dom";
const { RangePicker } = DatePicker;
const LooperTimer = ({
  type,
  open,
  setOpen,
  alias,
  setresult,
  setopenresult,
  intialCommand,
  setcommand,
}) => {
  const { siteid, timezone } = useSelector((state) => state.projectSite);
  const { username } = useSelector((state) => state.userDetails);

  const [triggerCommand, { isLoading, error, isError, data }] =
    useTriggerCommandMutation();
  const [daysofWeek, setDaysOfWeek] = useState([
    { id: 0, short: "sunday" },
    { id: 0, short: "monday" },
    { id: 0, short: "tuesday" },
    { id: 0, short: "wednesday" },
    { id: 0, short: "thursday" },
    { id: 0, short: "friday" },
    { id: 0, short: "saturday" },
  ]);

  const [loopTimer, { isLoading: luploading }] = useLoopTimerMutation();

  const [timeRange, setTimeRange] = useState([]);
  const [frequency, setFrequency] = useState("weekly");
  const [state, setstate] = useState("connectedstate");
  const [connectionminute, setconnectionminute] = useState(null);
  const [disconnection, setdisconnection] = useState(null);
  const [startstate, setstartstate] = useState(0);
  const [stopstate, setstopstate] = useState(0);
  const { meterid } = useParams();
  const { name: domainname } = useSelector((state) => state.projectSite);

  const handleDayClick = (index) => {
    setDaysOfWeek((prev) =>
      prev.map((day, i) =>
        i === index ? { ...day, id: day.id === 0 ? 1 : 0 } : day
      )
    );
  };

  const handleTimeChange = (value) => {
    setTimeRange(value);
  };

  const handleFrequencyChange = (type) => {
    setFrequency(type);
  };

  const handleStatehange = (type) => {
    setstate(type);
  };
  const formatDate = (date) => {
    return timezone
      ? convertToNigerianTime(date, timezone, "YYYY-MM-DD")
      : date;
  };

  const handleSubmit = () => {
    const selectedDays = daysofWeek.map((day) => day.id).join("");

    if (type === "meter") {
      loopTimer({
        meterid,
        daybinaries: selectedDays,
        starttime: moment(timeRange[0]._d).format("HH:mm").replace(":", ""),
        endtime: moment(timeRange[1]._d).format("HH:mm").replace(":", ""),
        startdate: moment(timeRange[0]._d)
          .format("YY-MM-DD")
          .replaceAll("-", ""),
        enddate: moment(timeRange[1]._d).format("YY-MM-DD").replaceAll("-", ""),
        onetimeaction: frequency === "once" ? 0 : 1,
        connectminutes: connectionminute,
        disconnectminutes: disconnection,
        startstate,
        stopstate,
      });
    } else {
      if (timeRange.length == 0) {
        notification.error({
          message: "Error",
          description: "Please selected a time range",
        });
        return;
      }
      if (!disconnection) {
        notification.error({
          message: "Error",
          description: "the delay field is required",
        });
        return;
      }

      if (!connectionminute) {
        notification.error({
          message: "Error",
          description: "Active time span is required",
        });
        return;
      }
      const selectedDays = daysofWeek.map((day) => day.id).join("");
      triggerCommand({
        alias,
        commandType: "LUP",
        daybinaries: selectedDays,
        starttime: moment(timeRange[0]._d).format("HH:mm").replace(":", ""),
        endtime: moment(timeRange[1]._d).format("HH:mm").replace(":", ""),
        startdate: moment(timeRange[0]._d)
          .format("YY-MM-DD")
          .replaceAll("-", ""),
        enddate: moment(timeRange[1]._d).format("YY-MM-DD").replaceAll("-", ""),
        onetimeaction: frequency === "once" ? 0 : 1,
        connectminutes: connectionminute,
        disconnectminutes: disconnection,
        transactiontopic: domainname + "/mqtt_" + username,
        siteid,
      })
        .then((res) => {
          if (res.error) {
            notification.error({
              message: "Failed",
              description: "Failed to complete command",
            });
            return;
          } else {
            // console.log(res.data, "response");
            setresult(res.data);
            setopenresult(true);
            setOpen(false);
            setcommand(intialCommand);
            notification.success({
              message: "Success",
              description: "Request for loop timer sent",
            });
          }
        })
        .catch((res) => {
          errorBlock(res);
        });
    }
  };

  return (
    <Drawer
      className="relative"
      title="Loop Timer"
      placement="right"
      onClose={() => setOpen(null)}
      open={open}
      width={400}
    >
      <p>
        Configure when meters in segmentation should be active. Select specific
        days of the week, set a time range, and choose how frequently it should
        repeat.
      </p>

      <Divider orientation="left" className="!text-[14px]">
        ⏰ Time
      </Divider>
      <div className="font-semibold">
        Time range <span className="text-[11px] font-light mb-2">(24hrs)</span>
      </div>
      <div className="mt-2">
        <RangePicker
          format={"YYYY-MM-DD HH:mm:ss"}
          showTime
          className="!w-full rounded-md"
          //   size="large"
          onChange={handleTimeChange}
        />
      </div>

      {/* <Divider orientation="left" className="!text-[14px] !mt-10">
        ⏳ Time span
      </Divider> */}

      <div className="flex mt-6 flex-col">
        <label className="text-sm m-0 font-semibold">
          Delay for how long{" "}
          <span className="text-[11px] font-light mb-2">(minutes)</span>{" "}
        </label>
        <span className="text-[11px] font-light mb-2">
          (how long should the command be delayed before starting)
        </span>
        <InputNumber
          onChange={(e) => setconnectionminute(e)}
          className="!w-full"
          placeholder="Enter time"
        />
      </div>

      <div className="flex flex-col mt-6">
        <label className="text-sm m-0 font-semibold">
          Active time span{" "}
          <span className="text-[11px] font-light mb-2">(minutes)</span>{" "}
        </label>
        <span className="text-[11px] font-light mb-2">
          (how long should the command be active)
        </span>
        <InputNumber
          onChange={(e) => setdisconnection(e)}
          className="!w-full"
          placeholder="Enter time"
        />
      </div>

      <Divider orientation="left" className="!text-[13px] !mt-10">
        📅 Active days
      </Divider>
      <div className="grid grid-cols-4 gap-4">
        {daysofWeek.map((day, index) => (
          <div
            key={index}
            onClick={() => handleDayClick(index)}
            className={`flex h-[80px] transition duration-200 cursor-pointer capitalize rounded-md shadow-sm flex-col items-center justify-center 
            ${
              day.id === 1
                ? "bg-blue-500 text-white"
                : "bg-blue-50 hover:bg-blue-500 hover:text-white"
            }`}
          >
            <div className="font-semibold text-[12px]">{day.short}</div>
          </div>
        ))}
      </div>

      <Divider orientation="left" className="!text-[13px] !mt-10">
        📅 Frequency
      </Divider>
      <h1 className="mt-4 font-semibold">
        How often should this command take place?
      </h1>
      <div className="flex mt-2 items-center justify-between">
        <p className="font-light">Repeat every week</p>
        <Switch
          checked={frequency === "weekly"}
          onChange={() => handleFrequencyChange("weekly")}
        />
      </div>
      <div className="flex items-center justify-between">
        <p className="font-light">Just once</p>
        <Switch
          checked={frequency === "once"}
          onChange={() => handleFrequencyChange("once")}
        />
      </div>
      <h1 className="mt-4 font-semibold">
        How should the command take effect?
      </h1>
      <div className="flex mt-2 items-center justify-between">
        <p className="font-light">It should start in connection state</p>
        <Switch
          checked={startstate}
          onChange={(e) => setstartstate(e ? 1 : 0)}
        />
      </div>
      <div className="flex items-center justify-between">
        <p className="font-light">It should end in disconnection state</p>
        <Switch checked={stopstate} onChange={(e) => setstopstate(e ? 1 : 0)} />
      </div>

      <Button
        loading={isLoading || luploading}
        type="primary"
        htmlType="button"
        className=" mt-10 w-full !bg-primary !border-none"
        onClick={handleSubmit}
      >
        Save Schedule
      </Button>
    </Drawer>
  );
};

export default LooperTimer;
